import React from 'react';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import Policy from '../components/policy/Policy';

const policy = () => {
    return (
        <>
            <Header />
            <Policy/>
            <Footer/>
        </>
    );
};

export default policy;